import { useEffect } from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Clock, Home } from 'lucide-react'

export default function AnamneseExpiradaPage() {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-orange-100 p-4">
      <div className="max-w-2xl mx-auto py-8">
        <Card className="shadow-lg">
          <CardHeader className="text-center">
            <div className="flex justify-center mb-4">
              <Clock className="h-16 w-16 text-amber-500" />
            </div>
            <CardTitle className="text-2xl text-amber-700">
              Link Expirado
            </CardTitle>
            <CardDescription>
              Este link de acesso à anamnese expirou e não está mais disponível.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6 text-center">
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
              <p className="text-amber-800">
                O prazo para preenchimento deste formulário encerrou. Por favor,
                entre em contato com o residencial responsável para solicitar um novo link.
              </p>
            </div>

            <div className="space-y-3">
              <p className="text-gray-600">
                Nosso sistema remove o acesso automaticamente após o prazo definido
                para garantir a segurança dos seus dados.
              </p>

              <Button
                onClick={() => window.location.href = 'https://idmovi.com'}
                className="w-full sm:w-auto"
              >
                <Home className="mr-2 h-4 w-4" />
                Ir para Página Inicial
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
